<script setup>
const bullets = [
    {
        title: "Everything in one place. ",
        text: "Projects, time tracking, team chat, workforce oversight, and more on a single platform.",
    },
    {
        title: "Real time visibility.",
        text: "See what your team is working on, how they are performing, and where things stand with live monitoring by your AI assistant.",
    },
    {
        title: "Managers lead.",
        text: "Your leaders spend time on execution and strategy instead of chasing status updates across five apps.",
    },
    {
        title: "Data sovereignty.",
        text: "Your operational data lives on your platform, fully structured and owned by you.",
    },
    {
        title: "Built for AI readiness.",
        text: "The unified foundation that makes automation actually useful.",
    },
];

const features = [
    {
        icon: "/images/auth/contact-round.svg",
        title: "17,000+",
        subtitle: "shifts",
    },
    {
        icon: "/images/auth/clock.svg",
        title: "147,000+",
        subtitle: "hours",
    },
    {
        icon: "/images/auth/message-circle-more.svg",
        title: "1,335,000+",
        subtitle: "messages",
    },
];
</script>

<template>
    <div
        class="auth-layout-wrapper flex-1-1-0 d-flex justify-center align-center"
    >
        <v-img
            class="auth-fixed-logo position-fixed h-auto"
            src="/images/auth/logo-black.svg"
        />
        <div
            style="max-width: 900px"
            class="container d-flex align-start ga-10"
        >
            <div class="left-section">
                <v-img
                    class="mb-5 logo"
                    src="/images/auth/logo-black.svg"
                    alt="Kamfu Logo"
                >
                </v-img>

                <div class="mb-9 d-flex align-end justify-start">
                    <h1 class="auth-heading">
                        Build and manage your team on
                        <img
                            max-width="150px"
                            height="23px"
                            src="/images/auth/logo-black.svg"
                            class="heading-logo"
                            alt="Kamfu Logo"
                        />
                    </h1>
                </div>

                <ul class="mb-5">
                    <template v-for="(item, index) in bullets" :key="index">
                        <li class="mb-3 text-body-1">
                            <img
                                src="/images/auth/k-circle-black.svg"
                                width="24"
                                class="pa-0"
                                style="margin-right: 11.5px"
                                alt="Check"
                            />
                            <div style="font-weight: 400">
                                <span
                                    v-if="item.title"
                                    class="font-weight-bold"
                                >
                                    {{ item.title }}
                                </span>
                                {{ item.text }}
                            </div>
                        </li>
                    </template>
                </ul>

                <div
                    class="features d-flex align-center justify-space-between ga-5 pt-1"
                >
                    <div
                        v-for="(feature, index) in features"
                        :key="index"
                        class="feature"
                    >
                        <img
                            :src="feature.icon"
                            :alt="feature.subtitle"
                            width="40"
                        />
                        <div>
                            <h3>{{ feature.title }}</h3>
                            <p>{{ feature.subtitle }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-section">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../sass/_theme-variables.sass";
@import "../../../../sass/_colors.sass";
@import url("https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Roboto:ital,wght@0,100..900;1,100..900&display=swap");

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.auth-layout-wrapper {
    background: RGBA(255, 255, 255, 1);
    background: linear-gradient(
        82deg,
        $fontDark 8%,
        rgba(206, 206, 206, 1) 64%,
        $fontDark
    );
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    height: 100vh;
    padding: 70px 10px;
    font-family: "Roboto", sans-serif;

    .auth-fixed-logo {
        top: 10px;
        left: 10px;
        width: 100px;
        z-index: 1000;
    }

    .right-section {
        width: 350px;
    }

    .left-section {
        color: $fontLight;
        .auth-heading {
            font-size: 24px;
            font-family: "Poppins", serif !important;
        }

        ul li {
            display: flex;
            align-items: start;
            font-weight: 500;
            font-size: 1.2rem;

            img {
                border-radius: 50%;
                max-width: 24px;
                max-height: 24px;
                background-size: cover;
                padding: 0.2rem;
            }
        }

        .features {
            margin-left: 34px;
            .feature {
                line-height: normal;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 8px;
                img {
                    // margin-bottom: 8px;
                    height: 30px;
                    width: 30px;
                }
                h3 {
                    font-size: 18px;
                    margin-bottom: 4px;
                    font-weight: bolder;
                }
                p {
                    font-size: 14px;
                    font-weight: 600;
                }
            }
        }

        hr {
            border: none;
            background-color: $sectionBorder;
            height: 1px;
        }
    }

    .logo {
        max-width: 150px;
    }

    @media (max-width: 1024px) {
        .left-section {
            .logo {
                margin: 0 auto 20px;
            }
            .auth-heading {
                justify-content: center;
            }
        }
    }
}
</style>
